// extracted by mini-css-extract-plugin
export default {"root":"fr0ocsbk","value":"fBDo2y8J","options":"_54k4D4h4","option":"OXNic5iP","isCurrent":"_8lqeBg8A"};